import { render, staticRenderFns } from "./LogoIndustry.vue?vue&type=template&id=78c3671d&scoped=true&"
import script from "./LogoIndustry.vue?vue&type=script&lang=js&"
export * from "./LogoIndustry.vue?vue&type=script&lang=js&"
import style0 from "./LogoIndustry.vue?vue&type=style&index=0&id=78c3671d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3671d",
  null
  
)

export default component.exports